import React from 'react';
import PropTypes from 'prop-types';
import * as Styled from './styles';
import { RunnerCard } from '../../RunnerCard';
import {
    affIds,
    BET,
    buildTransferLink,
    dcmpTags
} from '../../../helpers/transfers';
import { useFeatures } from '../../../hooks/useFeatures';
import { getRunnerPromotionConfig } from '../../../helpers/promotions';
import { useAuth } from '../../../hooks/useAuth';

const transferLink = (eventPath, isLoggedIn) => {
    return buildTransferLink({
        to: BET,
        dcmp: dcmpTags.horse,
        affId: affIds.horse,
        event: eventPath,
        isLoggedIn
    });
};

const SelectionAssigned = ({
    title,
    clothNumber,
    horseName,
    jockeyName,
    trainerName,
    silk,
    excludeFromBetting,
    bettingEnabled
}) => {
    const { features } = useFeatures();
    const { authStore } = useAuth();

    const runnerPromoConfig = getRunnerPromotionConfig({
        promotions: features.promotions
    });

    const showSkybetLink =
        !excludeFromBetting && bettingEnabled && runnerPromoConfig.enabled;

    const skybetLinkHref =
        showSkybetLink && runnerPromoConfig.enabled
            ? transferLink(runnerPromoConfig.eventPath, authStore.loggedIn)
            : undefined;

    return (
        <div>
            <Styled.Heading>My {title} Sweepstake Horse</Styled.Heading>
            <div>
                <RunnerCard
                    clothNumber={clothNumber}
                    horseName={horseName}
                    jockeyName={jockeyName}
                    trainerName={trainerName}
                    silk={silk}
                    showSkybetLink={showSkybetLink}
                    skybetLinkHref={skybetLinkHref}
                />
            </div>
        </div>
    );
};

SelectionAssigned.defaultProps = {
    clothNumber: null,
    jockeyName: null,
    trainerName: null,
    silk: null
};

SelectionAssigned.propTypes = {
    title: PropTypes.string.isRequired,
    clothNumber: PropTypes.string,
    horseName: PropTypes.string.isRequired,
    jockeyName: PropTypes.string,
    trainerName: PropTypes.string,
    silk: PropTypes.string,
    excludeFromBetting: PropTypes.bool.isRequired,
    bettingEnabled: PropTypes.bool.isRequired
};

export default SelectionAssigned;
